<div class="layoutBlock">
	<div class="columnHalf">
	
		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>
	
		<res-research-infrastructure-basic-data 
			[researchInfrastructure]="researchInfrastructure"
			[hisDynamicContent]="'I18nValue.basicData'"
			[dynamicComponent]="researchInfrastructure._dynamicComponent">
		</res-research-infrastructure-basic-data>
		
		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>
		
	</div>
	<div class="columnHalf">

		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>
	
		<!-- Betreibende Organisation -->
		<res-research-infrastructure-members-select 
			[organisations]="filteredOperators"
			[dynamicComponent]="researchInfrastructure._dynamicComponent"
			[isCoordinator]="false"
			[singleSelect]="false"
			hisDdKey="fs.res.researchInfrastructure.ResearchInfrastructure.operator"
			assignLink="fs.res.researchInfrastructure.ResearchInfrastructure.assignOperator"
			noAssignedMessage="fs.res.researchInfrastructure.ResearchInfrastructure.noOperatorAssigned"
			(organisationsChange)="operatorsChange($event)">
		</res-research-infrastructure-members-select>
		
		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>
		
		<!-- Koordinierende Organisation -->
		<res-research-infrastructure-members-select 
			[organisations]="filteredCoordinators"
			[dynamicComponent]="researchInfrastructure._dynamicComponent"
			[isCoordinator]="true"
			[singleSelect]="true"
			hisDdKey="fs.res.researchInfrastructure.ResearchInfrastructure.coordinator"
			assignLink="fs.res.researchInfrastructure.ResearchInfrastructure.assignCoordinator"
			noAssignedMessage="fs.res.researchInfrastructure.ResearchInfrastructure.noCoordinatorAssigned"
			(organisationsChange)="coordinatorsChange($event)">
		</res-research-infrastructure-members-select>
		
		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>
		
	</div>
</div>
